import React from 'react';
import { 
	func, 
	string,
	object 
} from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

const Presenter = ({
	editorProps,
	previewProps,
	className,
	t
}) =>{
	return (
		<style.Wrapper className={className}>
			<style.QuizDemoPresenter {...editorProps} />
			<style.Divider />
			<style.CreateQuizPreview  {...previewProps} />
		</style.Wrapper>
	);
};

Presenter.propTypes = {
	editorProps:object,
	previewProps:object,
	className:string,
	t:func.isRequired,
};

export default withNamespaces()(Presenter);